import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ButtonCommonTheme } from 'modules/theme'
import {
  ModalTrigger,
  Button,
  FormGroup,
  FormControl,
  ControlLabel
} from 'modules/common/components';

import { FormWrapper, FormColumn } from 'modules/common/styles/main';
import { ModalFooter } from 'modules/common/styles/main';
import APIManager from 'modules/common/apiManager';
import { Alert } from 'modules/common/utils';

const contextTypes = {
  __: PropTypes.func
};

class importFile extends Component {
  constructor(props) {
    super(props);
    this.closeModal = this.closeModal.bind(this);
    this.openModal = this.openModal.bind(this);
    this.importFile = this.importFile.bind(this);
    this.mAPI = new APIManager();
    this.state = {
      showHide: false,
      file: null
    };
  }

  componentWillUnmount() {
    // this.props.clearState();
  }

  closeModal() {
    this.setState({ showHide: false });
  }
  openModal() {
    this.setState({ showHide: true });
  }
  renderFormGroup(label, props) {
    return (
      <FormGroup>
        <ControlLabel required={props.required}>{label}</ControlLabel>
        <FormControl {...props} />
      </FormGroup>
    );
  }
  apiResponse(errorCode, data) {
    if (errorCode === 0) {
      let message = 'File Successfully Updated.';
      message = data && data.message ? data.message : 'Successfully updated';
      Alert.success(`${message}`);
      this.closeModal();
    } else {
      let message = data && data.message ? data.message : 'Something wrong happened';
      Alert.error(`${message}`);
    }
  }
  importFile(e) {
    let _this = this;
    const { apiUrl = '', fetchData } = this.props;
    let formData = fetchData(this.state.file);

    this.mAPI.sendPostForm(
      `${apiUrl}`,
      formData,
      data => {
        //Set the progress value to show the progress bar
        Alert.success(`File is added.`);
        this.closeModal();
        // this.handleModalShowImport();
        // this.resetAllData();
        // this.getList();
      },
      (errorCode, data) => {
        this.apiResponse(errorCode, data);
      }
    );
  }
  render() {
    const { __ } = this.context;
    const {
      buttonTitle = 'Import',
      title = 'Import',
      modalType = 'mid',
      fileAccept = '.csv',
      urlDownload = ''
    } = this.props;
    const importTrigger = (
      <Button
        btnStyle="default"
        size="small"
        icon="upload-6"
        style={{ marginLeft: '10px' }}
      >
        {buttonTitle}
      </Button>
    );
    return (
      <ModalTrigger
        title={title}
        trigger={importTrigger}
        size={modalType}
        showHide={this.state.showHide}
        closeModal={this.closeModal}
        openModal={this.openModal}
        dialogClassName={modalType}
        backdrop={false}
      >
        <FormWrapper>
          <FormColumn>
            {this.renderFormGroup('File', {
              defaultValue: '',
              autoFocus: true,
              componentClass: 'file',
              type: 'file',
              value: '',
              accept: fileAccept,
              selectedFile: this.state.file,
              onChange: e => {
                if (e.target.files && e.target.files[0]) {
                  this.setState({ file: e.target.files[0] });
                } else {
                  this.setState({ file: null });
                }
              },
              id: 'file'
            })}
          </FormColumn>
        </FormWrapper>
        <ModalFooter>
          <div style={{ textAlign: 'left', marginBottom: '5px' }}>
            <Button
              btnStyle="link"
              size="small"
              icon="folder-download"
              target="_blank"
              href={this.mAPI.downloadUrl(`${urlDownload}`)}
            >
              {'Download Sample File'}
            </Button>
          </div>
          <ButtonCommonTheme type='greyModalBtn' modalBtnTitle='Cancel'
            btnStyle="simple"
            onClick={() => this.closeModal()}
            icon="cancel-1"
            size="small"
            style={{ marginRight: '10px' }}
          />
          <ButtonCommonTheme
            type='blueModalBtn'
            btnType='submit'
            modalBtnTitle='Save'
            btnStyle="default"
            onClick={() => this.importFile()}
            icon="checked-1"
            size="small" />
        </ModalFooter>
      </ModalTrigger>
    );
  }
}

importFile.contextTypes = contextTypes;

export default importFile;



// WEBPACK FOOTER //
// src/modules/common/components/ImportFile.js